import { 
    Drawer, 
    DrawerBody, 
    DrawerCloseButton, 
    DrawerContent, 
    DrawerHeader, 
    DrawerOverlay, 
    IconButton, 
    Link, 
    VStack 
} from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { IoMenu } from "react-icons/io5";
import useToggle from "@shared/hooks/useToggle";

const Navigation = () => {
    const [isOpen, setIsOpen, manualSetIsOpen] = useToggle()
    return(
        <>
            <IconButton aria-label="open menu" onClick={setIsOpen} icon={<IoMenu size={24}/>}/>
            <Drawer isOpen={isOpen} onClose={setIsOpen} placement="left" size="sm">
                <DrawerOverlay/>
                <DrawerContent>
                    <DrawerCloseButton/>
                    <DrawerHeader>Navegacion</DrawerHeader>
                    <DrawerBody>
                        <VStack spacing={2}>
                            <Link 
                                as={NavLink}
                                to="/empresas" 
                                display="block" 
                                w="100%" 
                                p={2} 
                                borderRadius={8}
                                _hover={{bg:"gray.100", color:"blue.600", shadow:"xs"}}
                                _activeLink={{bg:"gray.100", color:"blue.600", shadow:"xs"}}
                                onClick={() => manualSetIsOpen(false)}
                            >
                                Empresas
                            </Link>
                            {/* <Link 
                                as={NavLink} 
                                display="block" 
                                to="/procesos" 
                                w="100%" 
                                p={2} 
                                borderRadius={8} 
                                _hover={{bg:"gray.100", color:"blue.600", shadow:"xs"}}
                                _activeLink={{bg:"gray.100", color:"blue.600", shadow:"xs"}}
                                onClick={() => manualSetIsOpen(false)}
                            >
                                Procesos
                            </Link> */}
                            <Link
                                as={NavLink}
                                to="/empresas-proceso"
                                display="block"
                                w="100%"
                                p={2}
                                borderRadius={8}
                                _hover={{bg:"gray.100", color:"blue.600", shadow:"xs"}}
                                _activeLink={{bg:"gray.100", color:"blue.600", shadow:"xs"}}
                                onClick={() => manualSetIsOpen(false)}
                            >
                                Procesos por empresa
                            </Link>
                        </VStack>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    )
}

export default Navigation